/**
 * @generated SignedSource<<9f309f63f11b5fd6468d379557e3be64>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type hometaxBlockSettingsQuery$variables = Record<PropertyKey, never>;
export type hometaxBlockSettingsQuery$data = {
  readonly hometaxBlockSettings: {
    readonly bypassAuthEnabled: boolean;
    readonly corpQueueScreenEnabled: boolean;
    readonly corpWaitingCount: number | null | undefined;
    readonly queueScreenEnabled: boolean;
    readonly queueScreenStage: string;
    readonly waitingCount: number | null | undefined;
  };
};
export type hometaxBlockSettingsQuery = {
  response: hometaxBlockSettingsQuery$data;
  variables: hometaxBlockSettingsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "HometaxBlockSettingsOutput",
    "kind": "LinkedField",
    "name": "hometaxBlockSettings",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "bypassAuthEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "queueScreenEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "queueScreenStage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "waitingCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "corpQueueScreenEnabled",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "corpWaitingCount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "hometaxBlockSettingsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "hometaxBlockSettingsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "d081992c40b6fbb5303edff161aa2b62",
    "id": null,
    "metadata": {},
    "name": "hometaxBlockSettingsQuery",
    "operationKind": "query",
    "text": "query hometaxBlockSettingsQuery {\n  hometaxBlockSettings {\n    bypassAuthEnabled\n    queueScreenEnabled\n    queueScreenStage\n    waitingCount\n    corpQueueScreenEnabled\n    corpWaitingCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "d816f96b341e5d3b4bdba338675e2f6b";

export default node;
